'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'facebook',
    shape: _react2.default.createElement('path', {
        d: 'M0 0v48h25.638V29.412h-6.255v-7.244h6.255v-5.343c0-6.2 3.787-9.575 9.318-9.575 2.65 0 4.926.197 5.59.285v6.48l-3.836.002c-3.01 0-3.59 1.43-3.59 3.526v4.626l7.173-.002-.934 7.245h-6.24V48H48V0H0z'
    }),
    viewbox: '0 0 48 48',
    label: 'Facebook'
};
//# sourceMappingURL=facebook.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/facebook.js
 ** module id = 688
 ** module chunks = 1
 **/